import React from 'react'
import { Typography, outlinedInputClasses, useTheme, useMediaQuery } from '@mui/material'
import MuiPhoneNumber from 'material-ui-phone-number-2'

function FlatPhoneNumber({
  label,
  StartIcon,
  EndIcon,
  size = 'medium',
  backgroundColor,
  typographyProps,
  inputProps = {},
  ...props
}) {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
  const responsiveSize = isSmallScreen ? 'small' : size
  return (
    <>
      {!!label && (
        <Typography
          variant="body1"
          gutterBottom
          fontSize={responsiveSize}
          sx={{ fontSize: responsiveSize }}
          {...typographyProps}
        >
          {label}
        </Typography>
      )}
      <MuiPhoneNumber
        sx={{
          [`& .${outlinedInputClasses.root}`]: {
            backgroundColor,
          },
        }}
        inputProps={{
          style: {
            direction: 'ltr',
          },
          ...inputProps,
        }}
        size={responsiveSize}
        FormHelperTextProps={{ sx: { fontSize: responsiveSize } }}
        {...props}
      />
    </>
  )
}

export default FlatPhoneNumber
